import React, { useEffect } from 'react';
import ValidatedFormInput from 'components/ValidatedFormInput';
import validator from 'validator';
import {
  Grid,
  Form,
  Button,
  Checkbox,
  Container,
  Dimmer,
  Loader,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  setCheckField,
  updateInternalUser,
  updatingInternalUser,
  resetInternalUserPassword,
  openResetInternalUserPasswordModal,
  closeResetInternalUserPasswordModal,
} from 'state/access/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';
import ResetInternalUserPasswordForm from './ResetInternalUserPasswordForm';

const emptyStringValidation = (value = '') =>
  !validator.isEmpty(value) ? undefined : 'This field is required';

const emailValidation = value =>
  validator.isEmail(value) ? undefined : 'Invalid email address';

const EditInternalUserForm = props => {
  const {
    dispatch,
    allRoles,
    handleSubmit,
    editModal,
    updatingUser,
    resetPasswordModal,
  } = props;

  const onEditUserSubmit = ({ email }) => {
    const userId = editModal.selectedUser.id;
    dispatch(updatingInternalUser(true));
    const payload = { reqBody: {} };
    payload.reqBody.email = email;
    payload.reqBody.role_ids = allRoles
      .filter(role => role.isChecked)
      .map(role => role.id);
    payload.userId = userId;
    dispatch(updateInternalUser(payload));
  };
  const handleCheckFieldChange = index => {
    dispatch(setCheckField({ index, currRoles: allRoles }));
  };

  const handleResetPasswordButton = () => {
    dispatch(
      openResetInternalUserPasswordModal({
        selectedUser: editModal.selectedUser,
      })
    );
  };

  const onCloseResetUserPasswordModalClicked = () => {
    dispatch(closeResetInternalUserPasswordModal());
  };

  const onResetUserPassword = () => {
    dispatch(resetInternalUserPassword(resetPasswordModal.selectedUser));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      {/* reset user password modal  */}
      <Modal size="small" open={resetPasswordModal.isOpen}>
        <Modal.Header>
          <strong>Reset User Password</strong>
        </Modal.Header>
        <Modal.Content>
          <ResetInternalUserPasswordForm />
        </Modal.Content>
        <Modal.Actions>
          <Button primary inverted onClick={onResetUserPassword}>
            <Icon name="repeat" /> Yes
          </Button>
          <Button color="red" onClick={onCloseResetUserPasswordModalClicked}>
            <Icon name="close" /> No
          </Button>
        </Modal.Actions>
      </Modal>
      <SemanticToastContainer />
      <Dimmer active={updatingUser}>
        <Loader size="massive">Saving</Loader>
      </Dimmer>
      <Form onSubmit={handleSubmit(onEditUserSubmit)}>
        <Field
          id="email"
          name="email"
          component={ValidatedFormInput}
          icon="user"
          iconPosition="left"
          placeholder="Email"
          autoFocus
          validate={[emptyStringValidation, emailValidation]}
        />
        <h3>Roles</h3>
        <Grid>
          {allRoles.map((role, index) => (
            <Grid.Column key={role.id} mobile={16} tablet={8} computer={4}>
              <Checkbox
                key={role.id}
                checked={role.isChecked}
                label={role.name}
                onChange={() => handleCheckFieldChange(index)}
              />
            </Grid.Column>
          ))}
        </Grid>
        <br />
        <Container>
          <Button type="submit" primary inverted>
            <Icon name="save" />
            Save
          </Button>
          <Button
            type="reset"
            primary
            inverted
            onClick={handleResetPasswordButton}
          >
            <Icon name="repeat" />
            Reset Password
          </Button>
        </Container>
      </Form>
    </Container>
  );
};

const mapStateToProps = ({ access }) => ({
  editModal: access.editModal,
  allRoles: access.allRoles,
  creatingUser: access.creatingUser,
  initialValues: access.editModal.selectedUser,
  updatingUser: access.updatingUser,
  resetPasswordModal: access.resetPasswordModal,
});

EditInternalUserForm.propTypes = {
  editModal: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  allRoles: PropTypes.array.isRequired,
  updatingUser: PropTypes.bool.isRequired,
  resetPasswordModal: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'edit_user',
  })(EditInternalUserForm)
);
